import { render, staticRenderFns } from "./FormSugarCooker.vue?vue&type=template&id=35ce2d02&scoped=true&"
import script from "./FormSugarCooker.vue?vue&type=script&lang=js&"
export * from "./FormSugarCooker.vue?vue&type=script&lang=js&"
import style0 from "./FormSugarCooker.vue?vue&type=style&index=0&id=35ce2d02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ce2d02",
  null
  
)

export default component.exports